import React, {useCallback, useEffect, useState} from 'react';
import {DataGrid, GridOverlay} from '@mui/x-data-grid';
import CircularProgress from '@mui/material/CircularProgress';
import {getAllConsumableAssets, getAllConsumableAssetsCSV} from '../../../services/asset.service';
import {getDivisionAdditionalList} from '../../../services/user.service';
import * as CryptoJS from "crypto-js";
import './AssetInfo.css';
import './AssetList.css';
import {Box, Pagination} from '@mui/material';
import Select from "react-select";
import {Parser} from "json2csv";
import FromFieldDate from "../../../atoms/FromFieldDate";

/* ─── Date Helpers (unchanged) ─── */
Date.prototype.dbFormatedDate = function () {
    let year = this.getFullYear();
    let month = this.getMonth() + 1;
    let day = this.getDate();
    if (month < 10) month = '0' + month;
    if (day < 10) day = '0' + day;
    return year + '-' + month + '-' + day;
};

function getFormatedDate(dateString) {
    if (dateString != null) {
        let dte = new Date(dateString);
        let year = dte.getFullYear();
        let month = dte.getMonth() + 1;
        let day = dte.getDate();
        if (month < 10) month = '0' + month;
        if (day < 10) day = '0' + day;
        return year + '-' + month + '-' + day;
    } else {
        return null;
    }
}

const AllConsumableAssetList = () => {

    /* ─── Columns (backend unchanged – only renderCell class names updated) ─── */
    const columns = [
        {field: "sl_no", hideable: true, hide: true, editable: false, headerName: "Sl No", width: 50},
        {
            field: "tag", editable: false, hide: false, headerName: "TAG", width: 250,
            renderCell: (params) => {
                let EncryptID = CryptoJS.AES.encrypt(JSON.stringify({
                    'tag': params.row.tag, 'back_url': 'all-consumable-asset-list'
                }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
                return <a className="al-cell-tag-link" href={`/consumable-asset-details?tag=${EncryptID}`}><i className="bi bi-tag-fill"></i> {params.value}</a>;
            }
        },
        {field: "parent_tag", hideable: true, hide: false, editable: true, headerName: "Parent TAG", width: 250},
        {field: "grouping_name", editable: true, hide: false, headerName: "Grouping Name", width: 130},
        {field: "year_of_addition", hideable: true, hide: false, editable: true, headerName: "Year of Addition", width: 130},
        {field: "type_of_addition", editable: true, hide: false, headerName: "Type of Addition", width: 130},
        {field: "project_marking", editable: true, hide: false, headerName: "Project Marking", width: 130},
        {field: "po_no", editable: true, hide: false, headerName: "PO No (If Any)", width: 130},
        {field: "supplier_code", editable: true, hide: false, headerName: "Supplier Code (if Any)", width: 130},
        {field: "supplier_name", editable: true, hide: false, headerName: "Name of the Supplier", width: 130},
        {field: "invoice_no", editable: true, hide: false, headerName: "Invoice No", width: 130},
        {field: "invoice_date", editable: true, hide: false, headerName: "Invoice Date", width: 130, renderCell: (params) => <p>{getFormatedDate(params.row.invoice_date)}</p>},
        {field: "accounting_voucher_no", editable: true, hide: false, headerName: "Accounting voucher no", width: 130},
        {field: "internal_approval_no", editable: true, hide: false, headerName: "Internal approval no", width: 130},
        {field: "cost_center_code", editable: true, hide: false, headerName: "Cost center code", width: 130},
        {field: "cost_center_name", editable: true, hide: false, headerName: "Cost center name", width: 130},
        {field: "qty", editable: true, hide: true, headerName: "Qty", width: 130},
        {field: "asset_name", editable: true, hide: false, headerName: "Name of the Asset (as per Invoice)", width: 130},
        {field: "asset_description", editable: true, hide: false, headerName: "Detailed Description of the Asset", width: 130},
        {field: "asset_serial_no", editable: true, hide: false, headerName: "Unique Sl No of the Asset", width: 130},
        {field: "manufacturer", editable: true, hide: false, headerName: "Make / Manufacturer", width: 130},
        {field: "model_no", editable: true, hide: false, headerName: "Model No", width: 130},
        {field: "part_no", editable: true, hide: false, headerName: "Part No", width: 130},
        {field: "nature_of_presence", editable: true, hide: false, headerName: "Nature of Presence", width: 130},
        {field: "nature_of_addition", editable: true, hide: false, headerName: "Nature of Addition", width: 130},
        {field: "principal_asset_tag", editable: true, hide: false, headerName: "Principal Asset to which Cost is Added", width: 130},
        {field: "tag_name", editable: true, hide: false, headerName: "TAG Name", width: 130},
        {field: "tag_division", editable: true, hide: false, headerName: "TAG Division", width: 130},
        {field: "department_name", editable: true, hide: false, headerName: "Control Department Name", width: 180},
        {field: "unit_of_measure", editable: true, hide: false, headerName: "Unit of Measure", width: 130},
        {field: "created_at", editable: true, hide: false, headerName: "Date of Addition", width: 130, renderCell: (params) => <p>{getFormatedDate(params.row.created_at)}</p>},
    ];

    const CustomLoader = () => (
        <GridOverlay>
            <CircularProgress color="primary" size={30}/>
        </GridOverlay>
    );

    /* ─── All State (identical to original) ─── */
    const [items, setItems]                                   = useState([]);
    const [itemsCSV, setItemsCSV]                             = useState([]);
    const [searchTag, setSearchTag]                           = useState('');
    const [ErrSearchTag, setErrSearchTag]                     = useState(false);
    const [loading, setLoading]                               = useState(true);
    const [exloading, setExLoading]                           = useState(false);
    const [page, setPage]                                     = useState(1);
    const [totalItems, setTotalItems]                         = useState(0);
    const [pageSize, setPageSize]                             = useState(10);
    const [filterCriteria, setFilterCriteria]                 = useState('');
    const [ErrFilterCriteria, setErrFilterCriteria]           = useState(false);
    const [filterOperator, setFilterOperator]                 = useState('');
    const [ErrFilterOperator, setErrFilterOperator]           = useState(false);
    const [startDate, setStartDate]                           = useState('');
    const [ErrStartDate, setErrStartDate]                     = useState(false);
    const [endDate, setEndDate]                               = useState('');
    const [ErrEndDate, setErrEndDate]                         = useState(false);
    const [otherDivisions, setOtherDivisions]                 = useState([]);
    const [selectedOtherDivisions, setSelectedOtherDivisions] = useState([]);

    const calculateOffset = (page, pageSize) => (page - 1) * pageSize;

    /* ─── All Handlers (identical logic to original) ─── */
    const fetchAssets = useCallback(async () => {
        setLoading(true);
        const offset = calculateOffset(page, pageSize);
        const encryptedData = CryptoJS.AES.encrypt(JSON.stringify({
            param_data: {'offset': offset, 'pageSize': pageSize},
            authToken: sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        try {
            const res = await getAllConsumableAssets({token: encryptedData});
            if (res?.data?.data?.length) {
                setItems(res.data.data);
                setTotalItems(res.data.total || 0);
            } else {
                setItems('');
            }
        } catch (error) {
            console.error('Error fetching assets:', error);
        } finally {
            setLoading(false);
        }
    }, [page, pageSize]);

    const fetchAssets1 = async () => {
        setLoading(true);
        const offset = calculateOffset(page, pageSize);
        const encryptedData = CryptoJS.AES.encrypt(JSON.stringify({
            param_data: {
                'offset': offset, 'pageSize': pageSize, 'searchTag': searchTag,
                'filterCriteria': filterCriteria, 'filterOperator': filterOperator,
                'startDate': getFormatedDate(startDate), 'endDate': getFormatedDate(endDate),
            },
            authToken: sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        try {
            const res = await getAllConsumableAssets({token: encryptedData});
            if (res?.data?.data?.length) {
                setItems(res.data.data);
                setTotalItems(res.data.total || 0);
            } else {
                setItems('');
            }
        } catch (error) {
            console.error('Error fetching assets:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchAssetsCSV = useCallback(async () => {
        setExLoading(true);
        const offset = calculateOffset(page, pageSize);
        const encryptedData = CryptoJS.AES.encrypt(JSON.stringify({
            param_data: {
                'offset': offset, 'pageSize': pageSize, 'searchTag': searchTag,
                'filterCriteria': filterCriteria, 'filterOperator': filterOperator,
                'startDate': getFormatedDate(startDate), 'endDate': getFormatedDate(endDate),
                'other_division': otherDivisionIds,
            },
            authToken: sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        try {
            const resCSV = await getAllConsumableAssetsCSV({token: encryptedData});
            if (resCSV?.data?.data?.length) setItemsCSV(resCSV.data.data);
        } catch (error) {
            console.error('Error fetching assets CSV:', error);
        } finally {
            setExLoading(false);
        }
    }, [filterCriteria, filterOperator, searchTag, startDate, endDate, page, pageSize]);

    useEffect(() => { if (itemsCSV.length > 0) generateCSV(); }, [itemsCSV]);

    useEffect(() => { fetchAssets(page, pageSize); }, []);

    useEffect(() => {
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            param_data: {'other_division_ids': sessionStorage.getItem('LoggedInOtherDivisionIds')},
            authToken: sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        getDivisionAdditionalList({'token': EncryptData}).then(res => {
            if (res?.data?.data?.length) setOtherDivisions(res.data.data);
        });
    }, []);

    const handlePageSizeChange = (value) => {
        setPageSize(value);
        setPage(1);
        if (filterCriteria) fetchAssets1(1, value);
        else fetchAssets(1, value);
    };

    const handlePageChange = (event, value) => {
        setPage(value);
        if (filterCriteria) fetchAssets1(value, pageSize);
        else fetchAssets(value, pageSize);
    };

    const totalPages = Math.ceil(totalItems / pageSize);
    const handleExportToCSV = async () => { await fetchAssetsCSV(); };

    const generateCSV = () => {
        try {
            const jsonData = itemsCSV.map(item => ({
                tag: item.tag || '', parent_tag: item.parent_tag || '',
                year_of_addition: item.year_of_addition || '', type_of_addition: item.type_of_addition || '',
                project_marking: item.project_marking || '', po_no: item.po_no || '',
                supplier_code: item.supplier_code || '', supplier_name: item.supplier_name || '',
                invoice_no: item.invoice_no || '', invoice_date: item.invoice_date ? getFormatedDate(item.invoice_date) : '',
                boe_no: item.boe_no || '', boe_date: item.boe_date ? getFormatedDate(item.boe_date) : '',
                shipping_awb_no: item.shipping_awb_no || '', shipping_awb_date: item.shipping_awb_date ? getFormatedDate(item.shipping_awb_date) : '',
                accounting_voucher_no: item.accounting_voucher_no || '', internal_approval_no: item.internal_approval_no || '',
                cost_center_code: item.cost_center_code || '', cost_center_name: item.cost_center_name || '',
                qty: item.qty || '', asset_name: item.asset_name || '', asset_description: item.asset_description || '',
                asset_serial_no: item.asset_serial_no || '', manufacturer: item.manufacturer || '',
                model_no: item.model_no || '', part_no: item.part_no || '',
                nature_of_presence: item.nature_of_presence || '', nature_of_addition: item.nature_of_addition || '',
                principal_asset_tag: item.principal_asset_tag || '', tag_name: item.tag_name || '',
                tag_division: item.tag_division || '', department_name: item.department_name || '',
                unit_of_measure: item.unit_of_measure || '', security_seal_date: item.security_seal_date ? getFormatedDate(item.security_seal_date) : '',
                comp_ref_no: item.comp_ref_no || '', created_at: item.created_at ? getFormatedDate(item.created_at) : '',
            }));
            const json2csvParser = new Parser();
            const csv = json2csvParser.parse(jsonData);
            const blob = new Blob([csv], {type: 'text/csv;charset=utf-8;'});
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'All_Consumables_List.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error exporting data to CSV:', error);
        }
    };

    const handleSearch = () => {
        let isValid = true;
        if (!filterCriteria) { setErrFilterCriteria('Please select a filter criteria'); isValid = false; } else setErrFilterCriteria('');
        if (filterCriteria !== 'created_at' && !filterOperator) { setErrFilterOperator('Please select a filter operator'); isValid = false; } else setErrFilterOperator('');
        if (!searchTag && filterCriteria != 'created_at') { setErrSearchTag('Please enter a search text'); isValid = false; } else setErrSearchTag('');
        if (!startDate && filterCriteria == 'created_at') { setErrStartDate('Please select start date'); isValid = false; } else setErrStartDate('');
        if (!endDate && filterCriteria == 'created_at') { setErrEndDate('Please select end date'); isValid = false; } else setErrEndDate('');
        if (isValid) { setPage(1); fetchAssets1(); }
    };

    const options  = ["TAG Number","Year Of Addition","Type of Addition","PO Number","Supplier Name","Invoice Number","Asset Name","Make","Model Number","Asset Serial Number","Part Number","TAG Name","Nature of Presence","Date Range"];
    const values   = ["tag","year_of_addition","type_of_addition","po_no","supplier_name","invoice_no","asset_name","manufacturer","model_no","asset_serial_no","part_no","tag_name","nature_of_presence","created_at"];
    const combinedOptions = options.map((option, index) => ({label: option, value: values[index]}));

    const handleSelectChange = (e) => {
        const selectedOption = combinedOptions.find(option => option.value === e.target.value);
        setFilterCriteria(selectedOption ? selectedOption.value : '');
        setErrFilterCriteria('');
    };

    const optionsFilter  = ["Contains","Equals","Not Contains","Not Equals","Blank","Non Blank"];
    const valuesFilter   = ["LIKE","=","NOT LIKE","!=","IS NULL","IS NOT NULL"];
    const combinedOptionsFilter = optionsFilter.map((option, index) => ({label: option, value: valuesFilter[index]}));

    const handleOperatorChange  = (e) => { setFilterOperator(e.target.value); setErrFilterOperator(''); };
    const handelSearchText      = (e) => { setSearchTag(e.target.value); };

    const otherDivisionOptions = otherDivisions.map(option => ({value: option.id, label: option.division_name}));
    const handleOtherDivisions = (selectedOptions) => { setSelectedOtherDivisions(selectedOptions || []); };
    const otherDivisionIds = selectedOtherDivisions.map(option => option.value);

    /* ─── RENDER ─── */
    return (
        <div className="al-page" id="all-consumables-list-page">

            {/* ══ PAGE HEADER ══ */}
            <div className="al-page-header" id="al-page-header">
                <div className="al-page-header-left">
                    <div className="al-page-header-icon">
                        <i className="bi bi-box-seam"/>
                    </div>
                    <div className="al-page-header-text">
                        <h5 className="al-page-title">All Consumables List</h5>
                        <p className="al-page-subtitle">Browse and manage consumable assets inventory</p>
                    </div>
                </div>
                {!loading && (
                    <div className="al-record-badge" id="al-record-badge">
                        <i className="bi bi-layers-fill"/>
                        <strong>{totalItems.toLocaleString('en-IN')}</strong>&nbsp;Total Records
                    </div>
                )}
            </div>

            {/* ══ FILTER PANEL ══ */}
            <div className="al-filter-card" id="al-filter-panel">
                <div className="al-filter-card-header">
                    <span className="al-filter-card-title">
                        <i className="bi bi-funnel-fill"/> Search &amp; Filter
                    </span>
                </div>
                <div className="al-filter-card-body">

                    {/* Branch selector */}
                    {otherDivisionOptions.length > 0 && (
                        <div className="al-filter-row" id="al-branch-row">
                            <label className="al-filter-label">
                                <i className="bi bi-geo-alt-fill"/> Branch (Division)
                            </label>
                            <div className="al-filter-control-full">
                                <Select
                                    options={otherDivisionOptions}
                                    isMulti
                                    placeholder="Select one or more branches…"
                                    value={selectedOtherDivisions}
                                    onChange={handleOtherDivisions}
                                    classNamePrefix="al-select"
                                />
                            </div>
                        </div>
                    )}

                    {/* Criteria / Operator / Value */}
                    <div className="al-filter-grid" id="al-filter-grid">
                        <div className="al-filter-group">
                            <label className="al-filter-label">
                                Select Criteria <span className="al-required-star">*</span>
                            </label>
                            <select className="al-form-select" value={filterCriteria} onChange={handleSelectChange}>
                                <option value="" disabled>Select Filter Criteria</option>
                                {combinedOptions.map((opt, i) => (
                                    <option key={i} value={opt.value}>{opt.label}</option>
                                ))}
                            </select>
                            {ErrFilterCriteria && <span className="al-field-error"><i className="bi bi-exclamation-circle"/> {ErrFilterCriteria}</span>}
                        </div>

                        {filterCriteria !== 'created_at' && (
                            <div className="al-filter-group">
                                <label className="al-filter-label">
                                    Select Operator <span className="al-required-star">*</span>
                                </label>
                                <select className="al-form-select" value={filterOperator} onChange={handleOperatorChange}>
                                    <option value="" disabled>Select Operator</option>
                                    {combinedOptionsFilter.map((opt, i) => (
                                        <option key={i} value={opt.value}>{opt.label}</option>
                                    ))}
                                </select>
                                {ErrFilterOperator && <span className="al-field-error"><i className="bi bi-exclamation-circle"/> {ErrFilterOperator}</span>}
                            </div>
                        )}

                        {filterCriteria !== 'created_at' && (
                            <div className="al-filter-group al-filter-group-wide">
                                <label className="al-filter-label">
                                         <span className="al-required-star">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="al-form-input"
                                    placeholder="Type search value…"
                                    inputValue={searchTag}
                                    onChange={handelSearchText}
                                />
                                {ErrSearchTag && <span className="al-field-error"><i className="bi bi-exclamation-circle"/> {ErrSearchTag}</span>}
                            </div>
                        )}
                    </div>

                    {/* Date range */}
                    {filterCriteria === 'created_at' && (
                        <div className="al-date-grid" id="al-date-grid">
                            <div className="al-filter-group">
                                <FromFieldDate label="Start Date" placeholder="Select Start Date"
                                    inputValue={startDate} setInputValue={setStartDate} setErrorMsg={ErrStartDate}/>
                            </div>
                            <div className="al-filter-group">
                                <FromFieldDate label="End Date" placeholder="Select End Date"
                                    inputValue={endDate} setInputValue={setEndDate} setErrorMsg={ErrEndDate}/>
                            </div>
                        </div>
                    )}

                    {/* Buttons */}
                    <div className="al-filter-actions" id="al-filter-actions">
                        <button className="al-btn al-btn-primary" id="al-search-btn" onClick={handleSearch}>
                            <i className="bi bi-search"/> Search Assets
                        </button>
                        <button className="al-btn al-btn-outline" id="al-export-btn" onClick={handleExportToCSV} disabled={loading}>
                            {exloading ? (
                                <><span className="al-dot"/><span className="al-dot"/><span className="al-dot"/> Exporting…</>
                            ) : (
                                <><i className="bi bi-file-earmark-arrow-down"/> Export All to CSV</>
                            )}
                        </button>
                    </div>
                </div>
            </div>

            {/* ══ DATA GRID CARD ══ */}
            <div className="al-grid-card" id="al-grid-card">
                <div className="al-grid-card-header">
                    <span className="al-grid-card-title">
                        <i className="bi bi-table"/> Consumable Asset Records
                    </span>
                    {!loading && items.length > 0 && (
                        <span className="al-showing-badge">
                            Showing <strong>{items.length}</strong> of <strong>{totalItems.toLocaleString('en-IN')}</strong>
                        </span>
                    )}
                </div>

                <Box>
                    <DataGrid
                        rows={items}
                        getRowId={(row) => row.sl_no}
                        columns={columns}
                        autoHeight
                        className="al-data-grid"
                        components={{
                            LoadingOverlay: CustomLoader,
                            Pagination: () => (
                                <Box className="al-pagination-bar">
                                    <div className="al-page-size-row">
                                        <span className="al-page-size-label">Rows per page</span>
                                        <Select
                                            options={[
                                                {value: 10, label: '10'}, {value: 25, label: '25'},
                                                {value: 50, label: '50'}, {value: 100, label: '100'},
                                                {value: 200, label: '200'}, {value: 500, label: '500'},
                                            ]}
                                            value={{value: pageSize, label: pageSize.toString()}}
                                            onChange={(sel) => handlePageSizeChange(sel.value)}
                                            classNamePrefix="al-select"
                                            menuPlacement="top"
                                            styles={{container: (b) => ({...b, minWidth: 80})}}
                                        />
                                    </div>
                                    <Pagination
                                        count={totalPages}
                                        page={page}
                                        onChange={handlePageChange}
                                        variant="outlined"
                                        shape="rounded"
                                        size="small"
                                    />
                                </Box>
                            ),
                        }}
                        loading={loading}
                        sx={{
                            border: 'none',
                            fontFamily: "var(--font-body)",
                            '& .MuiDataGrid-columnHeaders': {
                                color: '#fff', fontSize: '0.75rem', fontWeight: 700,
                                textTransform: 'uppercase', letterSpacing: '0.5px', borderBottom: 'none',
                            },
                            '& .MuiDataGrid-columnHeaderTitle':    {color: '#000',fontSize: '0.88rem'},
                            '& .MuiDataGrid-sortIcon': {color: 'rgb(46 45 45 / 85%)'},
                            '& .MuiDataGrid-menuIconButton': {color: 'rgb(46 45 45 / 85%)'},
                            '& .MuiDataGrid-iconButtonContainer .MuiIconButton-root': {color: 'rgba(255,255,255,0.85)'},
                            '& .MuiDataGrid-row':                  {fontSize: '0.8rem'},
                            '& .MuiDataGrid-row:hover':            {backgroundColor: '#eef7fd'},
                            '& .MuiDataGrid-row.Mui-selected':     {backgroundColor: '#d8f0fa'},
                            '& .MuiDataGrid-cell':                 {borderColor: '#f0f2f5'},
                            '& .MuiDataGrid-footerContainer':      {borderTop: '1px solid #e2e6ef', background: '#f8f9fc'},
                            '& .MuiDataGrid-virtualScroller':      {backgroundColor: '#fff'},
                        }}
                    />
                </Box>
            </div>
        </div>
    );
};

export default AllConsumableAssetList;